/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ToggleButtonComponent} from './toggle-button.component';
import {ReactiveFormsModule} from '@angular/forms';
import {PipesModule} from '../pipes/pipes.module';

@NgModule({
    declarations: [ToggleButtonComponent],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        PipesModule
    ],
    exports: [ToggleButtonComponent]
})
export class ToggleButtonModule {
}
